import { Frame } from "scenejs";
import { breakpoints } from 'constants/breakpoints';

import _ from 'lodash';
import { CONTENT, CONTENT_CARD, FORM, FORM_FIELD, FORM_STEP, PAGE, SECTION, SECTION_COLUMN, MENU, EXTERNAL_FORM, HOTSPOT, CAROUSEL, CAROUSEL_CARD, ASSET, SEEK, LIVE_ELEMENT_CONTAINER, MODAL, SLIDE, GROUP, LIVE_ELEMENT } from "constants/widgetTypes";
import { WidgetRegistry } from "../widgets/registry";
import store from "../../../store.jsx";


export function getPositionForNewWidget(editor, parentDimension, dimension) {
  const state = store.getState();
  const gatingEditor = _.get(state, `${editor}.present.entityType`) === "GATING";
  const storyboardType = _.get(state, "storyboards.storyboard.item.type");
  const isValidStoryboard = storyboardType === "LANDING_PAGE" || storyboardType === "RESOURCE_CENTER";

  const selectedPage = _.get(state, `${editor}.present.activeSegment`) || _.get(state, `${editor}.present.selectedPage`) ;
  const selectPageContainer = document.querySelector(`#${editor} .editor_widget_scroll_container .editor-page-wrapper #${selectedPage}`);
  const scrollContainer = document.querySelector(`#${editor} .editor_widget_scroll_container`);

  const rect = scrollContainer.getBoundingClientRect();

  let pageoffset = 0;

  function getElementOffsetTop(element) {
    let top = 0;
    while (element) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    return top - 255;
  }

  if(selectedPage) {
    pageoffset = scrollContainer.scrollTop -  getElementOffsetTop(selectPageContainer) ;
  }

  var x = (parseFloat(parentDimension?.width) - parseFloat(dimension?.width)) / 2;
  var y = scrollContainer.scrollTop + ((rect.height - parseFloat(dimension.height)) / 2) - 100;

  if (isValidStoryboard && !gatingEditor && selectedPage && parentDimension?.height) {
    y = pageoffset + ((rect.height - parseFloat(dimension.height)) / 2) - 100;

    const parentHeight = parseFloat(parentDimension.height);
    if (parentHeight < y || y < 0) {
      y = parentHeight / 2;
    }
  }

  x = Math.max(0, x);
  y = Math.max(0, y);

  return {
    x, y
  }
}
  
/**
 * Calculate dimension for a widget
 */
export function recalculateLayoutForBreakpoint(context, widget) {
  const editorSession = context.editorSession;
  const breakpoint = context.breakpoint;

  var layoutsMap = {}
  context.widgets.forEach(widget => {
    const layout = _.get(widget, `properties.${breakpoint}.layout`);
    layoutsMap[widget.uid] = layout;
  });

  const newContext = {
    ...context,
    layouts: layoutsMap,
    topOffset: 20,
    padding: {
      horizontal: 20,
      vertical: 10
    },
    availableWidth: 375
  }

  _recalculateLayoutForBreakpoint(newContext, widget, 0);

  //Merge the layout maps
  context.layouts = newContext.layouts;

  context.widgets.forEach(widget => {
    var layout = context.layouts[widget.uid];
    const type = widget.type;

    const widgetConfig = WidgetRegistry.moveableConfig(editorSession, type, breakpoint);
    if (widgetConfig && widgetConfig.onResize) {
      layout = widgetConfig.onResize(widget, layout, breakpoint);
    }

    context.layouts[widget.uid] = layout;
  });

  return context.layouts;
}

function _recalculateLayoutForBreakpoint(context, widget, index) {
  const {
    editorSession,
    widgets,
    breakpoint,
    availableWidth,
    padding
  } = context;

  //Create new context
  const newContext = calculateContextForWidget(context, widget);

  if (newContext) {
    var children = widgets.filter(item => item.parent === widget.uid);
    children = sortWidgetsByPosition(editorSession, children);

    children.forEach((child, index) => {
      _recalculateLayoutForBreakpoint(newContext, child, index);
    });

    //Merge the layout maps
    context.layouts = newContext.layouts;
  }

  const layout = _calculateLayoutForWidget(context, widget, index);
  if (layout) {
    context.layouts[widget.uid] = layout;
  }
}

/**
 * Calculate dimension for a widget
 * context: 
 *  - editor Session
 *  - widgets
 *  - Map of calculated widget layouts
 *  - Breakpoint
 *  - Available width
 *  - Padding - json object with horizonatal and vertical padding
 *  - Top offset
 * widget - widget object
 * index - Position of the widget in the children
*/
function _calculateLayoutForWidget(context, widget, index) {

  const {
    editorSession,
    widgets,
    breakpoint,
    layouts,
    availableWidth,
    topOffset,
    padding
  } = context;

  const layout = layouts[widget.uid];
  var newLayout = new Frame(layout);

  const type = widget.type;
  var rect = null;


  var leftOffset = padding.horizontal;
  var topOffsetValue = topOffset;

  switch (type) {
    case PAGE:
      rect = calculateDimensionForContainer(context, widget, availableWidth);
      break;
    case SLIDE:
      rect = calculateDimensionForContainer(context, widget, availableWidth);
      break;
    case FORM:
      rect = calculateDimensionForForm(context, widget, availableWidth);
      break;
    case FORM_STEP:
      rect = calculateDimensionForContainer(context, widget, availableWidth);
      break;
    case FORM_FIELD:
      rect = calculateFormInputDimension(editorSession, widget, availableWidth);
      break;
    case SECTION:
      leftOffset = 0;
      if (index == 0) {
        topOffsetValue = 0;
      }
      rect = calculateSectionDimension(context, widget, 375);
      break;

    case MENU:
      leftOffset = 0;
      if (index == 0) {
        topOffsetValue = 0;
      }
      rect = calculateSectionDimension(context, widget, 375);
      break;

    case CAROUSEL:
            leftOffset = 0;
      if (index == 0) {
        topOffsetValue = 0;
      }
      rect = calculateCarouselDimension(context, widget, 375);
      break;
    
    case CAROUSEL_CARD: 
    leftOffset = 0;
    if (index == 0) {
      topOffsetValue = 0;
    }
    rect = calculateCarouselCardDimension(context, widget, 375);
    break;

    case SEEK:
      leftOffset = 0;
      if (index == 0) {
        topOffsetValue = 0;
      }
      rect = calculateSeekDimension(context, widget, 375);
      break;
    
    case SECTION_COLUMN:
      leftOffset = 0;
      rect = calculateSectionColumnDimension(context, widget, 375);
      break;

    case CONTENT:
      leftOffset = 0;
      if (index == 0) {
        topOffsetValue = 0;
      }
      rect = calculateWidgetDimension(editorSession, widget, 375);
      break;
    case HOTSPOT: 
      rect = calculateDimensionForHotspot(context, widget, availableWidth);
      break;
    case ASSET: 
      leftOffset = 0;
      rect = calculateWidgetDimension(editorSession, widget, 375);
      break;
  
    default:
      rect = calculateWidgetDimension(editorSession, widget, availableWidth);
  }

  if (!rect || rect.width === 0) {
    return newLayout.get();
  }

  newLayout.set('width', `${rect.width}px`);
  newLayout.set('height', `${rect.height}px`);

  if (newLayout.has('transform', 'translate')) {
    newLayout.set('transform', 'translate', `${leftOffset}px, ${topOffsetValue}px`);
  }

  context.topOffset = topOffsetValue + rect.height + padding.vertical;

  return newLayout.get();
}

export function calculateWidgetDimension(editor, widget, availableWidth) {
  const layoutHelper = document.querySelector(`#${editor} .widget_layout_helper`);
  if (!layoutHelper) {
    return null;
  }

  const widgetElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.uid}`);
  if (!widgetElement) {
    return null;
  }

  const rect = widgetElement.getBoundingClientRect();

  const newWidth = Math.min(availableWidth, rect.width);
  const newHeight = rect.height > 0 ? (rect.height / rect.width) * newWidth : 0;

  const newRect = new DOMRect(rect.x, rect.y, newWidth, newHeight);
  return newRect;
}

function calculateFormInputDimension(editor, widget, availableWidth) {
  const widgetElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.uid}`);
  if (!widgetElement) {
    return null;
  }

  const rect = widgetElement.getBoundingClientRect();

  const newWidth = Math.min(availableWidth, rect.width);
  const newHeight = rect.height;

  const newRect = new DOMRect(rect.x, rect.y, newWidth, newHeight);
  return newRect;
}


export function calculateDimensionForContainer(context, widget, availableWidth) {
  const {
    editorSession,
    widgets,
    layouts,
    padding
  } = context;

  var containerRect = calculateWidgetDimension(editorSession, widget, availableWidth);
  if (!containerRect) {
    return null;
  }

  var height = 0;
  var children = widgets.filter(item => item.parent === widget.uid);
  children.forEach(child => {
    const layout = layouts[child.uid];
    const rect = getBoundingRectFromLayout(layout);

    if (rect && !isNaN(rect.height)) {
      const offset = rect.y + rect.height;
      height = Math.max(offset, height);
    }
  });

  containerRect.height = height + padding.vertical;
  return containerRect;
}

export function calculateDimensionForCarouselContainer(context, widget, availableWidth) {
  const {
    editorSession,
    widgets,
    layouts,
    padding
  } = context;

  var containerRect = calculateWidgetDimension(editorSession, widget, availableWidth);
  if (!containerRect) {
    return null;
  }

  var height = 0;
  var children = widgets.filter(item => item.parent === widget.uid);

  children.forEach(child => {
    const layout = layouts[child.uid];
    const rect = getBoundingRectFromLayout(layout);
    if (rect && !isNaN(rect.height)) {
      height = Math.max(rect.height, height);
    }
  });

  containerRect.height = height + padding.vertical;
  return containerRect;
}


export function calculateDimensionForHotspot(context, widget, availableWidth) {
  const {
    editorSession,
    widgets,
    layouts,
    padding
  } = context;

  var containerRect = calculateWidgetDimension(editorSession, widget, availableWidth);
  if (!containerRect || containerRect.width === 0) {
    return null;
  }

  var height = 0;
  var children = widgets.filter(item => item.parent === widget.uid);
  children.forEach(child => {
    const layout = layouts[child.uid];
    const rect = getBoundingRectFromLayout(layout);

    if (rect && !isNaN(rect.height)) {
      const offset = rect.y + rect.height;
      height = Math.max(offset, height);
    }
  });

  containerRect.height = height + padding.vertical;
  return containerRect;
}

export function calculateDimensionForForm(context, widget, availableWidth) {

  const {
    editorSession,
    widgets,
    layouts,
    padding
  } = context;

  var containerRect = calculateWidgetDimension(editorSession, widget, availableWidth);
  if (!containerRect) {
    return null;
  }

  var children = widgets.filter(item => item.parent === widget.uid);

  var height = 0;
  children.forEach(child => {
    const layout = layouts[child.uid];
    const rect = getBoundingRectFromLayout(layout);

    if (rect && !isNaN(rect.height)) {
      height = Math.max(rect.height, height);
    }
  });

  containerRect.height = height;
  return containerRect;
}

export function calculateSectionDimension(context, widget, availableWidth) {
  const newContext = calculateContextForWidget(context, widget);
  const containerRect = calculateDimensionForContainer(newContext, widget, availableWidth) || {};

  containerRect.width = 375;

  return containerRect;
}

export function calculateSeekDimension(context, widget, availableWidth) {
  const newContext = calculateContextForWidget(context, widget);
  const containerRect = calculateWidgetDimension(newContext.editorSession, widget, availableWidth);
  containerRect.width = 375;

  return containerRect;
}

export function calculateCarouselCardDimension(context, widget, availableWidth) {
  const newContext = calculateContextForWidget(context, widget);
  const containerRect = calculateDimensionForContainer(newContext, widget, availableWidth) || {};

  containerRect.width = availableWidth;
  return containerRect;
}

let widgetMaxHeights = 0;
let slideIdWithHeights = {};

export function calculateCarouselDimension(context, widget, availableWidth) {
  const newContext = calculateContextForWidget(context, widget);
  const containerRect = calculateDimensionForCarouselContainer(newContext, widget, availableWidth) || {};
  const currentHeight = containerRect.height || 0;
  const visibleSlideId = getCarouselSlideId(context, widget);
  const maxHeightSlideId = getMaxHeightSlideId(slideIdWithHeights);

  if (!visibleSlideId) return containerRect; 
  if (maxHeightSlideId === visibleSlideId) {
    widgetMaxHeights = 0;
  }

  widgetMaxHeights = Math.max(widgetMaxHeights || 0, currentHeight, 400);
  slideIdWithHeights[visibleSlideId] = widgetMaxHeights;
  
  if (maxHeightSlideId !== visibleSlideId){
    slideIdWithHeights[visibleSlideId] = Math.max(currentHeight, 400);;
  }

  containerRect.width = availableWidth;
  containerRect.height = widgetMaxHeights;

  return containerRect;
}

export function calculateSectionColumnDimension(context, widget, availableWidth) {
  const newContext = calculateContextForWidget(context, widget);
  const containerRect = calculateDimensionForContainer(newContext, widget, availableWidth) || {};
  const height = Math.max(containerRect.height ? containerRect.height : 0, 400);

  containerRect.width = availableWidth;
  containerRect.height = height;
  return containerRect;
}

function calculateContextForWidget(context, widget) {
  const {
    availableWidth,
    padding
  } = context;

  var topOffset = 20;

  var newPadding = {
    horizontal: 20,
    vertical: 20
  };

  var newWidth = availableWidth - 2 * newPadding.horizontal;
  const type = widget.type;

  switch (type) {
    case FORM:
    case EXTERNAL_FORM:
      newWidth = availableWidth;
      newPadding = {
        horizontal: 0,
        vertical: 20
      }
      topOffset = 0;
      break;
    case SECTION:
      newWidth = availableWidth;
      newPadding = {
        horizontal: 0,
        vertical: 0
      }
      topOffset = 0;
      break;
    case SEEK:
      newWidth = availableWidth;
      newPadding = {
        horizontal: 0,
        vertical: 0
      }
      topOffset = 0;
      break;
    case SECTION_COLUMN:
      newWidth = availableWidth;
      break;
    case CAROUSEL:
      newWidth = availableWidth;
      newPadding = {
        horizontal: 0,
        vertical: 0
      }
      topOffset = 0;
      break;
    case CAROUSEL_CARD:
      newWidth = availableWidth;
      break;
    case CONTENT:
    case CONTENT_CARD:
      return null;

    default:
      break;
  }

  const newContext = {
    ...context,
    topOffset: topOffset,
    availableWidth: newWidth,
    padding: newPadding
  }

  return newContext;
}

/**
 * Calculate the Best position to add next widget
*/
export function getBestPositionForBreakpoint(editor, breakpoint, widgets) {
  if (_.size(widgets) == 0) {
    return {
      x: 20,
      y: 20
    };
  }

  const deviceData = breakpoints[breakpoint];
  const { width, horizontalPadding } = deviceData;

  widgets = sortWidgetsByPosition(editor, widgets);
  const last = widgets[widgets.length - 1];

  const layout = _.get(last, `properties.${breakpoint}.layout`);
  var newLayout = new Frame(layout);
  newLayout.set('width', `${width - 2 * horizontalPadding}px`);
  newLayout.set('height', 'auto');

  const rect = calculateWidgetDimension(editor, last.uid, newLayout);

  const positon = new Frame(layout).get("transform", "translate");
  const value = positon.split(",").map(str => {
    str = str.trim();
    return parseFloat(str);
  });

  return {
    x: 20,
    y: value[1] + rect.height + 10
  }
}

export function sortWidgetsByPosition(editor, widgets) {
  if (_.size(widgets) == 0) {
    return widgets;
  }

  const result = [...widgets];

  const cache = new Map();

  const getElementRectange = (widget) => {
    const id = widget.uid;
    var rect = cache.get(id);
    if (rect == null) {
      const layout = _.get(widget, `properties.desktop.layout`);
      const positon = new Frame(layout).get("transform", "translate");
      if (positon) {
        const value = positon.split(",").map(str => {
          str = str.trim();
          return parseFloat(str);
        });

        rect = {
          x: value[0],
          y: value[1]
        }

      } else {
        rect = {
          x: 0,
          y: 0
        }
      }

      cache.set(id, rect);
    }

    if (rect == null) {
      return null;
    }

    return rect;
  }

  result.sort((w1, w2) => {
    const r1 = getElementRectange(w1);
    const r2 = getElementRectange(w2);

    if (r1.y == r2.y) {
      return r1.x - r2.x;
    }

    return r1.y - r2.y;
  });

  return result;
}

export function getStylesForLayout(layout, breakpoint, container, storyboardType, widgetType, isFreeSize = false) {
  var widgetStyle = new Frame(layout).toCSSObject();
  
  if (container) {
    const minWidth = _.get(container, `properties.${breakpoint}.container.minWidth`);
    const alignment = _.get(container, `properties.${breakpoint}.container.alignment.position`) || _.get(container, `properties.${breakpoint}.container.alignment`, 'center');

    var multiplier = 0.5;
    switch (alignment) {
      case 'left':
        multiplier = 0;
        break;

      case 'right':
        multiplier = 1;
        break;

      case 'center':
      default:
        multiplier = 0.5;
        break;
    }

    widgetStyle = {
      ...widgetStyle,
      marginLeft: minWidth ? `calc((100% - ${minWidth}px) * ${multiplier})` : '0px'
    }

    if ([CAROUSEL_CARD].includes(container?.type)) {
      if (isFreeSize ) {
        widgetStyle.marginLeft = '0px';
      }
    }
  }

  return widgetStyle;
}

export function getBoundingRectForWidgetsAlignment(editor, widgets, breakpoint) {
  var rect = null;

  if (_.size(widgets) == 0) {
    return rect;
  }

  widgets.forEach(widget => {
    const layout = _.get(widget, `properties.${breakpoint}.layout`);
    const elementRect = getBoundingRectForWidgetAlignment(editor, widget);

    if (!elementRect) {
      return;
    }

    if (rect == null) {
      rect = {
        x: elementRect.x,
        y: elementRect.y,
        width: elementRect.width,
        height: elementRect.height,
      };
    } else {
      rect = {
        x: Math.min(rect.x, elementRect.x),
        y: Math.min(rect.y, elementRect.y),
        width: Math.max(rect.x + rect.width, elementRect.x + elementRect.width) - Math.min(rect.x, elementRect.x),
        height: Math.max(rect.y + rect.height, elementRect.y + elementRect.height) - Math.min(rect.y, elementRect.y),
      };
    }
  });

  return rect;
}

export function getBoundingRectForWidgets(editor, widgets, breakpoint) {
  var rect = null;

  if (_.size(widgets) == 0) {
    return rect;
  }

  widgets.forEach(widget => {
    const layout = _.get(widget, `properties.${breakpoint}.layout`);
    const elementRect = getBoundingRectForWidget(editor, widget);

    if (!elementRect) {
      return;
    }

    if (rect == null) {
      rect = elementRect;
    } else {
      rect = {
        x: Math.min(rect.x, elementRect.x),
        y: Math.min(rect.y, elementRect.y),
        width: Math.max(rect.width, elementRect.width),
        height: Math.max(rect.height, elementRect.height),
      }
    }
  });

  return rect;
}

export function getBoundingRectFromLayout(layout) {
  if (!layout) {
    return null;
  }

  const frame = new Frame(layout);
  const translate = frame.get("transform", "translate") || '0px, 0px';
  const position = translate.split(",").map(str => {
    str = str.trim();
    return parseFloat(str);
  });

  const width = parseFloat(frame.get('width'));
  const height = parseFloat(frame.get('height'));

  return {
    x: position[0],
    y: position[1],
    width: width,
    height: height
  }
}

export function getBoundingRectForWidgetAlignment(editor, widget) {
  const widgetElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.uid}`);
  if (!widgetElement) {
    return null;
  }

  const parentRect = getParentRectAlignment(editor, widget);
  const rect = widgetElement.getBoundingClientRect();

  return {
    x: rect.left - parentRect.left,
    y: rect.top - parentRect.top,
    width: rect.width,
    height: rect.height
  };
}

export function getBoundingRectForWidget(editor, widget) {
  const widgetElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.uid}`);
  if (!widgetElement) {
    return null;
  }

  const parentRect = getParentRect(editor, widget);
  const rect = widgetElement.getBoundingClientRect();

  return {
    x: rect.left - parentRect.left,
    y: rect.top - parentRect.top,
    width: rect.width,
    height: rect.height
  };
}

function getParentRect(editor, widget) {
  if (!widget.parent) {
    return { left: 0, top: 0 };
  }

  const parentElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.parent}`);

  if (!parentElement) {
    return { left: 0, top: 0 };
  }

  const parentType = parentElement.getAttribute('data-widget-type');

  if(parentType === SECTION_COLUMN) {
    return {
      left: parentElement.parentElement?.getBoundingClientRect()?.left || 0,
      top: parentElement.parentElement?.getBoundingClientRect()?.top || 0,
    }
  }

  return {
    left: parentElement.getBoundingClientRect().left,
    top: parentElement.getBoundingClientRect().top,
  };
}

function getParentRectAlignment(editor, widget) {
  if (!widget.parent) {
    return { left: 0, top: 0 };
  }

  const parentElement = document.querySelector(`#${editor} .editor_widget_renderer #${widget.parent}`);

  if (!parentElement) {
    return { left: 0, top: 0 };
  }

  const parentStyle = getComputedStyle(parentElement);
  const transform = parentStyle.transform;
  const parentType = parentElement.getAttribute('data-widget-type');
  const matrix = new DOMMatrix(transform || 'none');

  return calculateParentRect(matrix, parentElement, parentType, transform);
}

function calculateParentRect(matrix, parentElement, parentType, transform) {
  const isSectionType = [SECTION, SECTION_COLUMN, MENU, GROUP].includes(parentType);
  const isContentType = [CONTENT, CONTENT_CARD].includes(parentType);
  const isPageType = [PAGE, SLIDE].includes(parentType);

  if (transform !== 'none') {
    if (isContentType) {
      return { left: matrix.m41, top: parentElement.getBoundingClientRect().top };
    } else if (isSectionType) {
      return { left: matrix.m41, top: 0};
    } else if (isPageType) {
      return { left: matrix.m41, top: matrix.m42 };
    }
  }

  return parentElement.getBoundingClientRect();
}


export function getWidgetBoundingRectForBreakpoint(editor, widget, breakpoint) {
  var widgetElement = getWidgetElementForBreakpoint(editor, widget.uid, breakpoint);

  if (!widgetElement) {
    return null;
  }

  var parentRect = new DOMRect();
  if (widget.parent != null) {
    var parentElement = getWidgetElementForBreakpoint(editor, widget.parent, breakpoint);
    if (parentElement) {
      parentRect = parentElement.getBoundingClientRect();
    }
  }

  const rect = widgetElement.getBoundingClientRect();

  return {
    x: rect.left - parentRect.left,
    y: rect.top - parentRect.top,
    width: rect.width,
    height: rect.height
  }
}

export function getWidgetPositionForBreakpoint(editor, widget, breakpoint) {
  var widgetElement = getWidgetElementForBreakpoint(editor, widget, breakpoint);

  if (!widgetElement) {
    return null;
  }

  var parentRect = new DOMRect();
  var pageElement = widgetElement.closest(`#${editor} .cs_page_root`) || widgetElement.closest(`#${editor} .cs_slide_root`);
  var gatingPage = widgetElement.closest(`#${editor} .cs_modal_widget`);
  if(pageElement) {
    parentRect = pageElement.getBoundingClientRect();
  }
  else if (gatingPage) {
    parentRect = gatingPage.getBoundingClientRect();
  }

  const rect = widgetElement.getBoundingClientRect();

  return {
    x: rect.left - parentRect.left,
    y: rect.top - parentRect.top,
    width: rect.width,
    height: rect.height
  }
}

export function getWidgetElementForBreakpoint(editor, id, breakpoint) {
  var widgetElement = document.querySelector(`#${editor} .editor_widget_scroll_container.${breakpoint} #${id}`);
  if (!widgetElement) {
    widgetElement = document.querySelector(`#${editor} .editor_device_preview.${breakpoint} #${id}`);
  }

  return widgetElement;
}

export function calculateHeightForWidget(editor, parent, widget) {
  const parentElement = document.querySelector(`#${editor} #${parent}`);
  const parentRect = parentElement.getBoundingClientRect();

  const _calculateHeightForWidget = (editor, id, parentRect) => {
    const widget = document.querySelector(`#${editor} #${id}`);
    const widgetRect = widget.getBoundingClientRect();

    var height = parentRect ? widgetRect.bottom - parentRect.top : widgetRect.height;

    const widgets = document.querySelectorAll(`#${editor} #${id} > .widget[data-widget-id]`);
    Array.from(widgets).forEach(element => {
      const childId = element.dataset.widgetId;
      const childHeight = _calculateHeightForWidget(editor, childId, parentRect);
      height = Math.max(height, childHeight);
    });

    return height;
  }

  return _calculateHeightForWidget(editor, widget, parentRect);
}

export function calculationByWidgetType(breakpoint, editorSession, calculatePosition, type, direction, storyboardType) {
  return (widgets, position, allWidgets) => {
    return widgets.map(child => {
      const layout = _.get(child, `properties.${breakpoint}.layout`);
      const frame = new Frame(layout);

      const childRect = getBoundingRectForWidgetAlignment(editorSession, child);
      const parentElement = document.querySelector(`#${editorSession} .editor_widget_renderer #${child.parent}`);
      const parentRect = parentElement.getBoundingClientRect();
      const parentType = parentElement ? parentElement.getAttribute('data-widget-type') : null;

      const gridLeft = parentElement?.querySelector('#gridOutLeft');
      const gridRight = parentElement?.querySelector('#gridOutRight');
      const pageGuideLine = document.querySelector('#forGuideLineWidth');

      const childPosition = calculatePosition(childRect, type, direction);
      const delta = position - childPosition;

      const translate = frame.get("transform", "translate").split(",").map(parseFloat);
      translate[type === "horizontal" ? 1 : 0] += delta;

      const setTransform = (x, y) => frame.set('transform', 'translate', `${x}px, ${y}px`);

      const storyboardTypeCondition = ['INTERACTIVE_CONTENT', 'SPATIAL'].includes(storyboardType);
      const widgetHasTransformChange = [LIVE_ELEMENT_CONTAINER, MODAL, HOTSPOT, GROUP];
      const isColumnWidget = parentType === SECTION_COLUMN;
      const isConditionalWidget = parentType === PAGE || SLIDE;
      let isContainerStretch;

      if ([MENU, CAROUSEL_CARD].includes(parentType)) {
        const parentData = allWidgets?.find(item => item.uid === child.parent);
        isContainerStretch = _.get(parentData, `properties.desktop.stretched`);
        if (parentType === CAROUSEL_CARD) {
          const grandParentData = allWidgets?.find(item => item.uid === parentData.parent);
          isContainerStretch = _.get(grandParentData, `properties.desktop.stretched`);
        }
      }

      if (widgets.length === 1 && !isColumnWidget && (isConditionalWidget || widgetHasTransformChange.includes(parentType))) {
        const { width: parentWidth, height: parentHeight } = parentRect;
        const { width: childWidth, height: childHeight } = childRect;

        if (type === 'vertical') {
          const verticalTransforms = {
            start: () => setTransform(0, translate[1]),
            center: () => setTransform((parentWidth / 2) - (childWidth / 2), translate[1]),
            end: () => setTransform(parentWidth - childWidth, translate[1])
          };
          verticalTransforms[direction]?.();
        } else {
          const horizontalTransforms = {
            start: () => setTransform(translate[0], 0),
            center: () => setTransform(translate[0], (parentHeight / 2) - (childHeight / 2)),
            end: () => setTransform(translate[0], parentHeight - childHeight)
          };
          horizontalTransforms[direction]?.();
        }
      } else if (isColumnWidget && widgets.length === 1) {
        if (type === 'vertical') {
          const gridLeftWidth = gridLeft?.getBoundingClientRect().width || 0;
          const gridRightWidth = gridRight?.getBoundingClientRect().width || 0;
          const commonWidth = gridLeftWidth == 0 ? gridRightWidth / 2 : gridRightWidth == 0 ? -gridLeftWidth / 2 : 0;

          const columnTransforms = {
            start: () => setTransform(translate[0] + gridLeftWidth, translate[1]),
            center: () => setTransform(translate[0] - commonWidth, translate[1]),
            end: () => setTransform(translate[0] - gridRightWidth, translate[1])
          };
          columnTransforms[direction]?.();
        } else {
          setTransform(...translate);
        }
      } else if (isContainerStretch && !storyboardTypeCondition) {
        if (type === 'vertical') {
          const pageGuideLineWidth = pageGuideLine?.getBoundingClientRect().width;

          const stretchTransforms = {
            start: () => setTransform(translate[0] + pageGuideLineWidth, translate[1]),
            center: () => setTransform(translate[0], translate[1]),
            end: () => setTransform(translate[0] - pageGuideLineWidth, translate[1])
          };
          stretchTransforms[direction]?.();
        } else {
          setTransform(...translate);
        }
      } else {
        setTransform(...translate);
      }

      return {
        id: child.uid,
        frame: frame
      };
    });
  };
}

export function getCarouselSlideId(context, widget) {
  const { widgets } = context;
  const children = widgets.filter(item => item.parent === widget.uid);
  
  const visibleSlide = children.find(slide => {
    const slideElement = document.getElementById(slide.uid);
    return slideElement?.getAttribute('data-selectable') !== null;
  });

  return visibleSlide ? visibleSlide.uid : null;
}

export function getMaxHeightSlideId(slideIdWithHeights) {
  let maxSlideId = null;
  let maxHeight = 0;

  for (const [slideId, height] of Object.entries(slideIdWithHeights)) {
    if (height > maxHeight) {
      maxHeight = height;
      maxSlideId = slideId;
    }
  }

  return maxSlideId;
}